import { Close, WarningAmber } from '@mui/icons-material'
import { IconButton, Portal } from '@mui/material'
import { useEffect, useState, useSyncExternalStore } from 'react'

import { getLanguage } from 'data/locale'
import { backendStore } from 'utils/backend'

const StatusCard = () => {
  const { t } = getLanguage()

  const { detectedSuspiciousActivity, ipBanned } = useSyncExternalStore(
    backendStore.subscribe,
    backendStore.getSnapshot
  )

  const [isVisible, setIsVisible] = useState(false)
  const [isIpBanned, setIsIpBanned] = useState(false)

  useEffect(() => {
    if (detectedSuspiciousActivity) {
      setIsVisible(true)
      setIsIpBanned(ipBanned)
      backendStore.clearSuspiciousActivityFlag()
    }
  }, [detectedSuspiciousActivity])

  if (!isVisible) {
    return null
  }

  return (
    <Portal>
      <div className="StatusCard-container">
        <div className="StatusCard-card">
          <div className="StatusCard-content">
            <WarningAmber className="StatusCard-icon" />
            <div className="StatusCard-text">
              {isIpBanned
                ? t.global.statusCard.suspiciousNetworkActivityDetected
                : t.global.statusCard.suspiciousActivityDetected}
            </div>
            <IconButton onClick={() => setIsVisible(false)}>
              <Close />
            </IconButton>
          </div>
        </div>
      </div>
    </Portal>
  )
}

export default StatusCard
